import React, { useContext, useEffect, useState } from "react";
import zohoLogo from "../../../../assets/images/zoho/zoho-logo.png";
import "./ZohoConnect.scss";
import IOnZohoUseGrantTokenDTO from "../../../../models/DTO/IOnZohoUseGrantTokenDTO";
import IZohoDisconnectDTO from "../../../../models/DTO/IZohoDisconnectDTO";
import IZohoUseGrantTokenDTO from "../../../../models/DTO/IZohoUseGrantTokenDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import OwButton from "../../../shared/OwButton/OwButton";
import SupplierContext from "../../../../contexts/SupplierContext";
import UserContext from "../../../../contexts/UserContext";
import { useLocation } from "react-router-dom";
import IZohoOnGetConnectionDetailDTO from "../../../../models/DTO/IZohoOnGetConnectionDetailDTO";
import IZohoGetConnectionDetailDTO from "../../../../models/DTO/IZohoGetConnectionDetailDTO";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    reloadSupplierFn: () => void;
};

export const ZohoConnect: React.FC<Props> = (props) => {
    const location = useLocation();
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    useEffect(() => {
        props.socket.on(EndpointsEnum.ZohoOnUseGrantToken, onUseGrantToken);
        props.socket.on(EndpointsEnum.ZohoOnDisconnect, onZohoDisconnect);
        props.socket.on(EndpointsEnum.ZohoOnGetConnectionDetail, onGetConnectionDetail);

        const params = new URLSearchParams(location.search);

        if (params) {
            const code = params.get("code");
            const loc = params.get("location");

            if (code && loc && !supplierModel.Supplier_Integration.has_zoho) {
                processGrantToken(code, loc);
            }
        }

        getConnectionDetail();

        return () => {
            props.socket.removeListener(EndpointsEnum.ZohoOnUseGrantToken, onUseGrantToken);
            props.socket.removeListener(EndpointsEnum.ZohoOnDisconnect, onZohoDisconnect);
            props.socket.removeListener(EndpointsEnum.ZohoOnGetConnectionDetail, onGetConnectionDetail);
        };
    }, []);

    const [clientId, setClientId] = useState<string>();
    const [redirectUri, setRedirectUri] = useState<string>();

    const startZohoConnection = () => {
        if (clientId && redirectUri) {
            const scope = "ZohoCRM.modules.ALL";
            const encodedRedirectUri = encodeURIComponent(redirectUri);

            const grantUrl: any = `https://accounts.zoho.com/oauth/v2/auth?scope=${scope}&client_id=${clientId}&response_type=code&access_type=offline&redirect_uri=${encodedRedirectUri}&prompt=consent`;

            window.location = grantUrl;
        }
    };

    const processGrantToken = (grantToken: string, loc: string) => {
        const payload: IZohoUseGrantTokenDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            grantToken,
            location: loc,
        };

        props.socket.emit(EndpointsEnum.ZohoUseGrantToken, payload);
    };

    const onUseGrantToken = (data: IOnZohoUseGrantTokenDTO) => {
        props.reloadSupplierFn();
    };

    const onZohoDisconnect = (data: any) => {
        props.reloadSupplierFn();
    };

    const getConnectionDetail = () => {
        const payload: IZohoGetConnectionDetailDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        props.socket.emit(EndpointsEnum.ZohoGetConnectionDetail, payload);
    };

    const onGetConnectionDetail = (data: IZohoOnGetConnectionDetailDTO) => {
        setRedirectUri(data.redirectUri);
        setClientId(data.clientId);
    };

    const disconnectZohoConnection = () => {
        const payload: IZohoDisconnectDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        props.socket.emit(EndpointsEnum.ZohoDisconnect, payload);
    };

    const hasZoho = supplierModel.Supplier_Integration.has_zoho;

    return (
        <div className="ZohoConnect">
            <OwAccordion
                hideChevron={!hasZoho}
                titleClick={hasZoho}
                leftImage={zohoLogo}
                leftImageHeight={30}
                rightElem={
                    <div className={"ms-auto"}>
                        {hasZoho ? (
                            <OwBadge title={"connected"} bgColor={"bg-success"} leftIconClass={"fas fa-check"} />
                        ) : (
                            <OwButton minWidth={150} title={"connect"} fn={startZohoConnection} />
                        )}
                    </div>
                }>
                <div>
                    <div className={hasZoho ? "detail-section" : "d-none"}>
                        <div className="d-flex flex-column">
                            <div>
                                <OwButton
                                    className={"btn-danger"}
                                    minWidth={150}
                                    title={"disconnect"}
                                    leftIconClass={"fas fa-unlink"}
                                    fn={disconnectZohoConnection}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </OwAccordion>
        </div>
    );
};

export default ZohoConnect;
